import { render, staticRenderFns } from "./CustomersLayout.vue?vue&type=template&id=517294e6&"
import script from "./CustomersLayout.vue?vue&type=script&lang=js&"
export * from "./CustomersLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports